import React, { useEffect } from 'react'
import Location from 'app/theme/forms/Location'
import Input from 'app/theme/forms/Input'
import Select from 'app/theme/forms/Select'

const locationStatuses = {
  confirmed: 'confirmed',
  unconfirmed: 'unconfirmed',
  approximate: 'approximate',
}

export default function LeadLocation(props) {
  const { data, setData, errors, setErrors, countries, country, regions } = props
  const showAddressZipFields = data.location_status && data.location_status !== 'approximate'

  const getAddressFields = () => {
    return (
      <>
        <Location
          label="Address"
          autoFocus
          value={data.address?.street}
          error={errors?.street}
          data-test-id='address'
          placeholder={data.recurring ? 'Location Address' : 'Event Address'}
          classNames={{
            div: '',
            input: 'input-underline',
            label: 'label block mb-2 text-base',
          }}
          onChange={(location, address) => {
            setData(prev => ({
              ...prev,
              address: address || {
                ...prev.address,
                street: location,
                location: null,
              }
            }))
            setErrors({
              ...errors,
              street: null
            })
          }}
        />
        <Input
          label="City*"
          value={data.address?.city_name}
          error={errors?.city_name}
          data-test-id='city_name'
          classNames={{
            input: 'input-underline',
            label: 'label block mb-2 text-base',
          }}
          onChange={city_name => {
            setData(prev => ({
              ...prev,
              address: {
                ...prev.address,
                city_name: city_name,
                location: null
              }
            }))
            setErrors({
              ...errors,
              city_name: null
            })
          }}
          required
        />
        <div className={["grid gap-6", showAddressZipFields ? 'md:grid-cols-2' : 'md:grid-cols-1']}>
          {(country?.code === 'US' && regions?.length) ? (
            <Select
              label="State*"
              placeholder="Choose A State"
              error={errors?.region_code}
              value={data.address?.region_code}
              classNames={{
                select: 'input-underline',
                label: 'label block mb-2 text-base',
              }}
              options={regions?.map(region => ({
                label: region.name,
                value: region.code
              }))}
              onChange={region_code => {
                setData(prev => ({
                  ...prev,
                  address: {
                    ...prev.address,
                    region_code
                  },
                }))
                setErrors(prev => ({
                  ...prev,
                  region_code: null,
                }))
              }}
              required
            />
          ) : (
            <Input
              label={(country?.region_label || 'State') + '*'}
              value={data.address?.region_code}
              error={errors?.region_code}
              data-test-id='region'
              classNames={{
                input: 'input-underline',
                label: 'label block mb-2 text-base capitalize',
              }}
              onChange={region_code => {
                setData(prev => ({
                  ...prev,
                  address: {
                    ...prev.address,
                    region_code,
                  },
                }))
                setErrors({
                  ...errors,
                  region_code: null
                })
              }}
              required
            />
          )}
          <Input
            label={(country?.zip_label || 'Zip') + '*'}
            value={data.address?.zip}
            error={errors?.zip}
            data-test-id='zip'
            classNames={{
              input: 'input-underline',
              label: 'label block mb-2 text-base capitalize'
            }}
            onChange={zip => {
              setData(prev => ({
                ...prev,
                address: {
                  ...prev.address,
                  zip: zip,
                  location: null
                }
              }))
              setErrors({
                ...errors,
                zip: null
              })
            }}
            required
          />
        </div>
        <Select
          label="Country"
          placeholder="Choose A Country"
          error={errors?.country}
          value={data.address?.country_code}
          classNames={{
            select: 'input-underline',
            label: 'label block mb-2 text-base',
          }}
          options={countries?.map((country) => ({
            label: country.name,
            value: country.code
          }))}
          onChange={selection => {
            const selected = countries.find(c => c.code === selection)

            if (!selected) return

            setData(prev => ({
              ...prev,
              address: {
                ...prev.address,
                country_name: selected.name,
                country_code: selected.code,
                region_name: null,
                region_code: null,
                location: null,
              },
            }))
            setErrors(prev => ({
              ...prev,
              country_code: null,
            }))
          }}
        />
        <span>*Required</span>
      </>
    )
  }

  const getSubmissionError = () => {
    return (
      <div className="font-bold px-8 py-3 text-center text-red-600">
        An unexpected error occurred. Please try to submit your details again in a few minutes.
      </div>
    )
  }

  const getLocationStatus = (data) => {
    if (data.address.street) {
      return locationStatuses.confirmed
    }
    else {
      return locationStatuses.approximate
    }
  }

  useEffect(() => {
    setData(prev => ({
      ...prev,
      location_status: getLocationStatus(prev)
    }))

  }, [data.address.street])


  return (
    <div>
      <div className="p-8">
        <p className="pb-4">
          To find the perfect food truck, let us know where the event will take place. 
          Not sure of the exact location? Just enter the city, state and zip code 
          to get started.
        </p>
        <div className="mb-3 grid gap-6">
          {
            countries.length > 0 &&
            getAddressFields()
          }
          { 
            Boolean(countries?.length) === false && getSubmissionError() 
          }
        </div>
      </div>
    </div>
  )
}
